import { fetchDatas, fetchData, createData, updateData, removeData, fetchApi } from '../reduxActions'
import { generateTypeName, generateTypeFunctions, getTypePath } from '../reduxTypes'


// Export Constants
const NAME_TYPE = ['RECEIVABLE_PAYMENTS', 'RECEIVABLE_PAYMENT']
const name = "receivable-payments"

// Type Names and Type Functions
export const { ADDS, ADDS_MORE, ADD, UPDATE, REMOVE } = generateTypeName(NAME_TYPE)
export const { adds, adds_more, add, update, remove } = generateTypeFunctions(NAME_TYPE)


// Export Actions
export const countReceivablePayments = (query, params = {}) => dispatch => {
  const { authName, dbNo, businessType, businesses_id } = query
  const path = getTypePath(businessType)

  return fetchApi({
    dispatch,
    params,
    api: `${path}${name}-count/${authName}/${dbNo}/${businesses_id}`,
  })
}

export const fetchReceivablePayments = (query, params = {}) => dispatch => {
  const { authName, dbNo, businessType, businesses_id } = query
  const path = getTypePath(businessType)

  return fetchDatas({
    dispatch,
    params,
    api: `${path}${name}/${authName}/${dbNo}/${businesses_id}`,
    add: adds,
    addMore: adds_more
  })
}

export const fetchReceivablePayment = (query, params = {}) => dispatch => {
  const { authName, dbNo, businessType, businesses_id, receivable_payments_id } = query
  const path = getTypePath(businessType)

  return fetchData({
    dispatch,
    params,
    api: `${path}${name}/${authName}/${dbNo}/${businesses_id}/${receivable_payments_id}`,
    add: add
  })
}

export const createReceivablePayment = (query, params) => dispatch => {
  const { authName, dbNo, businessType, businesses_id } = query
  const path = getTypePath(businessType)

  return createData({
    dispatch,
    params,
    api: `${path}${name}/${authName}/${dbNo}/${businesses_id}/create`,
    add: add
  })
}


export const updateReceivablePayment = (query, params) => dispatch => {
  const { authName, dbNo, businessType, businesses_id, receivable_payments_id, _id } = query
  const path = getTypePath(businessType)

  return updateData({
    dispatch,
    params,
    api: `${path}${name}/${authName}/${dbNo}/${businesses_id}/${_id || receivable_payments_id}`,
    update: update,
    updateId: _id || receivable_payments_id
  })
}

export const removeReceivablePayment = (query, params) => dispatch => {
  const { authName, dbNo, businessType, businesses_id, receivable_payments_id, _id } = query
  const path = getTypePath(businessType)

  return removeData({
    dispatch,
    params,
    api: `${path}${name}/${authName}/${dbNo}/${businesses_id}/${_id || receivable_payments_id}`,
    remove: remove,
    deleteId: _id || receivable_payments_id
  })
}
